export default "__VITE_ASSET__CAoM1FJd__"